var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _path9, _path10, _path11, _path12, _circle, _rect3, _rect4, _path13, _path14, _polygon, _path15, _path16, _path17, _path18, _path19, _path20, _line, _path21, _rect5, _rect6, _text, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObj25Mvl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731 356.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aae2c2;}.cls-2{fill:#50bd86;}.cls-3{fill:#434341;}.cls-4,.cls-6{fill:#fff;}.cls-5{fill:#ffdc00;}.cls-6{font-size:35px;font-family:CloserText-Black, Closer Text;font-weight:800;letter-spacing:0.05em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374,110.66l-36.27,1.84-.33-3,32.7-9.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.72,128.54l24,6c-2.05,7.76-13.43,5.58-24.54-4.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.54,93.15c3.1-14.23,7.69-18.25,15.12-14.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.64,70.88c4.81-9.6,9.42-18.83,15-29.88,1.63,3,4.57,6.39,3.87,7.57-4.66,7.84-10.08,15.24-15.33,22.72-.3.43-1.36.45-2.06.43C186.64,71.7,186.23,71.24,185.64,70.88Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.94,66.87c.94-8.58,1.71-15.6,2.49-22.75C185,46.82,184,57.44,175.94,66.87Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,112l4.88-8.41,20.64,16.57L42.84,123Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.14,92.43c-2.13,9.06-3.78,16-5.42,23l-2.5-.11c.24-6.67.26-13.36,1-20C51.29,94.38,54.72,93.79,58.14,92.43Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.53,147.47c-1.93-6.36,3.07-11.11,13.95-13.33Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 223.41,
    y: 250.15,
    width: 132.28,
    height: 44.84,
    rx: 10.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 250.32,
    y: 225.48,
    width: 78.47,
    height: 78.47,
    rx: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.39,305.16H252.72a3.61,3.61,0,0,1-3.61-3.61V227.89a3.61,3.61,0,0,1,3.61-3.61h73.67a3.61,3.61,0,0,1,3.6,3.61v73.66A3.61,3.61,0,0,1,326.39,305.16Zm-73.67-78.47a1.2,1.2,0,0,0-1.2,1.2v73.66a1.21,1.21,0,0,0,1.2,1.21h73.67a1.21,1.21,0,0,0,1.2-1.21V227.89a1.2,1.2,0,0,0-1.2-1.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.79,231.44V204.07a13.34,13.34,0,0,0-13.34-13.34H263.66a13.34,13.34,0,0,0-13.34,13.34v24.22a48.18,48.18,0,0,0,78.47,3.15Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.67,251.35A49.29,49.29,0,0,1,249.31,229l-.2-.3V204.07a14.56,14.56,0,0,1,14.55-14.54h51.79A14.55,14.55,0,0,1,330,204.07v27.78l-.25.32A49.09,49.09,0,0,1,290.67,251.35Zm-39.15-23.42A47,47,0,0,0,327.59,231v-27a12.16,12.16,0,0,0-12.14-12.14H263.66a12.15,12.15,0,0,0-12.14,12.14Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.85,198.14h-40.6v-7.09c0-12.29,8.81-22.3,19.63-22.3h1.35c10.82,0,19.62,10,19.62,22.3Zm-37-3.6h33.39v-3.49c0-10.31-7.19-18.69-16-18.69h-1.35c-8.83,0-16,8.38-16,18.69Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 289.55,
    cy: 232.21,
    r: 6.73
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 258.16,
    y: 264.72,
    width: 26.91,
    height: 26.91,
    rx: 1.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 294.04,
    y: 264.72,
    width: 26.91,
    height: 26.91,
    rx: 1.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157,290.12A98.13,98.13,0,1,0,58.84,192,98.16,98.16,0,0,0,157,290.12Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157,292.06A100.07,100.07,0,1,1,257.16,192,100.21,100.21,0,0,1,157,292.06Zm0-196.27A96.2,96.2,0,1,0,253.29,192,96.34,96.34,0,0,0,157,95.79Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "265.23 111.68 240.34 110.01 238.3 84.75 274.05 49.01 275.9 74.08 300.98 75.93 265.23 111.68"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266,113.67l-27.42-1.84L236.3,84l39.37-39.37,2,27.62,27.62,2Zm-23.83-5.48,22.34,1.5,32.14-32.14L274.1,75.88l-1.67-22.52L240.3,85.49Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157,269.66A77.67,77.67,0,1,0,79.32,192,77.69,77.69,0,0,0,157,269.66Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157,246.13A54.14,54.14,0,1,0,102.87,192,54.15,54.15,0,0,0,157,246.13Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157,248.06A56.07,56.07,0,1,1,213.14,192,56.15,56.15,0,0,1,157,248.06Zm0-108.27A52.2,52.2,0,1,0,209.27,192,52.28,52.28,0,0,0,157,139.79Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M157,219.12A27.13,27.13,0,1,0,129.89,192,27.13,27.13,0,0,0,157,219.12Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157,221.06A29.07,29.07,0,1,1,186.12,192,29.11,29.11,0,0,1,157,221.06Zm0-54.27A25.2,25.2,0,1,0,182.25,192,25.24,25.24,0,0,0,157,166.79Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 157.66,
    y1: 191.43,
    x2: 275.13,
    y2: 73.96
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.66,193.37a1.94,1.94,0,0,1-1.37-3.31L273.76,72.59a1.94,1.94,0,0,1,2.74,2.74L159,192.8A1.92,1.92,0,0,1,157.66,193.37Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 365.02,
    y: 187.76,
    width: 257,
    height: 34,
    rx: 17
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 374.02,
    y: 192.88,
    width: 85,
    height: 23.75,
    rx: 11.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(637.67 216.21)"
  }, "25%")), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M428.42,133.31a17.16,17.16,0,0,1,23.45,0,17.55,17.55,0,0,1,0,23.67,17.13,17.13,0,0,1-23.45,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.17,6.17,0,0,0,4.88,2.18A6.26,6.26,0,0,0,445,150.7a9,9,0,0,0,0-11.11,6.26,6.26,0,0,0-4.91-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M476.84,129.4a13.64,13.64,0,0,1,8.6,2.54,7.94,7.94,0,0,1,3.28,6.59,8.63,8.63,0,0,1-2.52,6.12,8.49,8.49,0,0,1,3.42,6.89,8.21,8.21,0,0,1-3.35,6.75,13.84,13.84,0,0,1-8.75,2.6h-16V129.4Zm-5.85,8v3.83h5.76a2.7,2.7,0,0,0,1.8-.57,1.72,1.72,0,0,0,.68-1.37,1.67,1.67,0,0,0-.68-1.35,2.8,2.8,0,0,0-1.8-.54Zm0,11.3v4.22h6.48a2.87,2.87,0,0,0,1.91-.58,2,2,0,0,0,.7-1.58,1.87,1.87,0,0,0-.72-1.46,2.86,2.86,0,0,0-1.89-.6Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M491.83,152.17a9,9,0,0,0,3.64.71c3,0,4.46-1.43,4.46-4.31V129.4h9.54v20.65a10.86,10.86,0,0,1-3.47,8.37,12.81,12.81,0,0,1-9,3.2q-3.73,0-5.13-1Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M515.36,129.4h24.3v8h-14.8v3.74h12.73v7.74H524.86v4h15.25v8H515.36Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M562.79,137.36v23.53H553.3V137.36h-9.5v-8h28.48v8Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M576.74,129.4h9.49v31.49h-9.49Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M590.42,129.4h10.35l6.93,19.21,6.79-19.21h10.35l-12.91,31.49h-8.51Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M630.65,133.31a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.12,17.12,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.17,6.17,0,0,0,4.88,2.18,6.24,6.24,0,0,0,4.9-2.18,8.92,8.92,0,0,0,0-11.11,6.24,6.24,0,0,0-4.9-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj25Mvl);
export default __webpack_public_path__ + "static/media/Obj_25-mvl.df6d9acafbf8694562f15a03172a1a72.svg";
export { ForwardRef as ReactComponent };